export async function postRequest(url: string, data: any) {
    const res = await fetch(url, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        body: `{"data": ${JSON.stringify(data)}}`,
        cache: "no-cache",
    });

    if (!res.ok) {
        return { status: res.status };
    }

    const contentType = res.headers.get("Content-Type");
    if (contentType && contentType.includes("application/json")) {
        return await res.json(); // Parse the JSON if the Content-Type is JSON
    } else {
        return { status: res.status };
    }
}
